const normalizeDataset = <T>(raw: unknown): T[] => {
  if (!raw) return []
  if (
    typeof raw === 'object' &&
    !Array.isArray(raw) &&
    'data' in (raw as any)
  ) {
    return normalizeDataset((raw as any).data)
  }
  return raw as T[]
}

export default normalizeDataset
